import classNames from 'classnames';
import { FC } from 'react';

interface HorizontalTimelineProps {
  label: string;
  date?: string;
  customIndicator?: React.ReactNode;
  className?: string;
  isLast?: boolean;
  isCurrent?: boolean;
  isPast?: boolean;
  isFuture?: boolean;
}

const HorizontalTimeline: FC<HorizontalTimelineProps> = ({
  label,
  customIndicator,
  isLast = false,
  isCurrent = false,
  isPast = false,
  isFuture = false,
}) => {
  return (
    <div className={`flex ${isLast ? 'w-auto' : 'w-full'}`}>
      <div className="flex items-center flex-row w-full">
        <div className="flex-shrink-0 relative">
          {customIndicator || (
            <div
              className={classNames(
                'h-4 w-4 rounded-full',
                isPast && 'bg-green-600',
                isFuture && 'bg-gray-200',
                isCurrent && 'bg-blue-600 animate-pulse h-3 w-3 opacity-75'
              )}
            />
          )}
          {label && (
            <p
              className={`text-xs text-gray-600 absolute top-5 transform -translate-x-1/3 text-center ${
                isCurrent ? 'font-semibold' : ''
              }`}
            >
              {label}
            </p>
          )}
        </div>
        {!isLast && <div className="flex-1 w-full h-0.5 bg-gray-200" />}
      </div>
    </div>
  );
};

export default HorizontalTimeline;
